import { AddCircleOutline } from "@mui/icons-material";
import { Button } from "@mui/material";
import React, { useState } from "react";
import { T } from "../../components/T";
import CreateNewProjectModal from "../../modals/CreateNewProjectModal";
import { useDeviceSize } from "../../hooks/useDeviceSize";

const CreateProjectButton = () => {
  const { xsDevice } = useDeviceSize();
  const [showCreateDialog, setShowCreateDialog] = useState(false);

  if (xsDevice) return null;

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        startIcon={<AddCircleOutline />}
        onClick={() => setShowCreateDialog(true)}
        sx={{
          marginRight: "2rem",
        }}
      >
        <T str="Create new project" />
      </Button>

      <CreateNewProjectModal
        isOpen={showCreateDialog}
        close={() => setShowCreateDialog(false)}
      />
    </>
  );
};

export default CreateProjectButton;
